module.exports = __webpack_public_path__ + "img/dy_1@2x.c008d516.png";